import moment from 'moment';
import dayjs from 'dayjs';
import 'moment/locale/de';
import 'moment/locale/uk';
import 'dayjs/locale/de';
import 'dayjs/locale/uk';
import enUS from 'antd/locale/en_US';
import deDE from 'antd/locale/de_DE';
import ukUA from 'antd/locale/uk_UA';

// Site language code (language.code in the DB) → locales of the libraries
const LOCALES = {
  'en-US': { antd: enUS, date: 'en' },
  'de-DE': { antd: deDE, date: 'de' },
  uk: { antd: ukUA, date: 'uk' },
};

export const getAntdLocale = (code) => LOCALES[code]?.antd || enUS;

export const applyDateLocale = (code) => {
  const date = LOCALES[code]?.date || 'en';
  moment.locale(date);
  dayjs.locale(date);
};

// Importing moment locales switches the global one to the last import
applyDateLocale(localStorage.getItem('languageSite'));
